/** biome-ignore-all lint/complexity/useSimpleNumberKeys: this rule would messup our color codes like 500_8 => 5008 */
import { alpha, type ThemeOptions } from '@mui/material';
import type { DeepPartial } from 'types/utils';

// Base color: #3D646E, step up 8%, step down 11%
// https://www.tailwindshades.com/#color=192.24489795918367%2C28.654970760233915%2C33.529411764705884&step-up=8&step-down=11&hue-shift=0&name=william&base-stop=5&v=1&overrides=e30%3D
const primary = {
  lighter: '#8EB6C0',
  light: '#5A94A2',
  main: '#3D646E',
  dark: '#152226',
  darker: '#010202',
};

// https://www.tailwindshades.com/#color=144%2C40%2C47.05882352941176&step-up=8&step-down=11&hue-shift=0&name=ocean-green&base-stop=5&v=1&overrides=e30%3D
const success = {
  lighter: '#B4DFC5',
  light: '#7BC699',
  main: '#48A86E',
  dark: '#26593B',
  darker: '#163221',
};

// https://www.tailwindshades.com/#color=29.04255319148936%2C88.67924528301886%2C58.4313725490196&step-up=8&step-down=11&hue-shift=0&name=jaffa&base-stop=5&v=1&overrides=e30%3D
const warning = {
  lighter: '#FCE6D1',
  light: '#F8BC84',
  main: '#F39237',
  dark: '#E4760E',
  darker: '#7A3F07',
};

// Base color: #9FA6A8, step up 8%, step down 14%
// https://www.tailwindshades.com/#color=191.68831168831167%2C5%2C64&step-up=8&step-down=11&hue-shift=0&name=gray-chateau&base-stop=5&v=1&overrides=e30%3D
const grey = {
  100: '#F4F5F5',
  200: '#DFE1E2',
  300: '#C9CECF',
  400: '#B4BABB',
  500: '#9FA6A8',
  600: '#798386',
  700: '#575F60',
  800: '#353A3B',
  900: '#131515',
  500_8: alpha('#9FA6A8', 0.08),
  500_12: alpha('#9FA6A8', 0.12),
  500_16: alpha('#9FA6A8', 0.16),
  500_24: alpha('#9FA6A8', 0.24),
  500_32: alpha('#9FA6A8', 0.32),
  500_48: alpha('#9FA6A8', 0.48),
  500_56: alpha('#9FA6A8', 0.56),
  500_80: alpha('#9FA6A8', 0.8),
};

export const themeOptions: DeepPartial<ThemeOptions> = {
  palette: {
    primary,
    success,
    warning,
    grey,
    background: {
      default: '#135160',
    },
    text: {
      primary: grey[800],
      secondary: grey[600],
      disabled: grey[500],
    },
    action: {
      hover: alpha(primary.main, 0.16), // Dropdown menu hover background color
    },
    navBar: {
      menuActiveBg: primary.main,
      menuActiveText: '#fff',
      menuDefaultText: grey[200],
      menuHoverBg: alpha(primary.main, 0.48),
      menuHoverText: '#fff',
      menuSecondaryText: grey[300],
      searchHoverBorder: primary.light,
    },
  },
};
